/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_AddressRename_Array_ } from '../models/ControllerResponse_AddressRename_Array_';
import type { ControllerResponse_AllowedWebsiteDomain_Array_ } from '../models/ControllerResponse_AllowedWebsiteDomain_Array_';
import type { ControllerResponse_boolean_ } from '../models/ControllerResponse_boolean_';
import type { ControllerResponse_BuildingOverride_Array_ } from '../models/ControllerResponse_BuildingOverride_Array_';
import type { ControllerResponse_DoMergeAddress_Array_ } from '../models/ControllerResponse_DoMergeAddress_Array_';
import type { ControllerResponse_DoNotMerge_Array_ } from '../models/ControllerResponse_DoNotMerge_Array_';
import type { ControllerResponse_ExcludedUrl_Array_ } from '../models/ControllerResponse_ExcludedUrl_Array_';
import type { ControllerResponse_PrioritizeListing_Array_ } from '../models/ControllerResponse_PrioritizeListing_Array_';
import type { ControllerResponse_ProposedEdit_Array_ } from '../models/ControllerResponse_ProposedEdit_Array_';
import type { ControllerResponse_SightmapUrl_Array_ } from '../models/ControllerResponse_SightmapUrl_Array_';
import type { Omit_AddressRename_created_on_or_created_by_ } from '../models/Omit_AddressRename_created_on_or_created_by_';
import type { Omit_AllowedWebsiteDomain_created_on_or_created_by_ } from '../models/Omit_AllowedWebsiteDomain_created_on_or_created_by_';
import type { Omit_BuildingOverride_created_on_or_created_by_ } from '../models/Omit_BuildingOverride_created_on_or_created_by_';
import type { Omit_DoMergeAddress_created_on_or_created_by_ } from '../models/Omit_DoMergeAddress_created_on_or_created_by_';
import type { Omit_DoNotMerge_created_on_or_created_by_ } from '../models/Omit_DoNotMerge_created_on_or_created_by_';
import type { Omit_ExcludedUrl_created_on_or_created_by_ } from '../models/Omit_ExcludedUrl_created_on_or_created_by_';
import type { Omit_PrioritizeListing_created_on_or_created_by_ } from '../models/Omit_PrioritizeListing_created_on_or_created_by_';
import type { Omit_SightmapUrl_created_on_or_created_by_ } from '../models/Omit_SightmapUrl_created_on_or_created_by_';
import type { Partial_AddressRename_ } from '../models/Partial_AddressRename_';
import type { Partial_AllowedWebsiteDomain_ } from '../models/Partial_AllowedWebsiteDomain_';
import type { Partial_BuildingOverride_ } from '../models/Partial_BuildingOverride_';
import type { Partial_DoMergeAddress_ } from '../models/Partial_DoMergeAddress_';
import type { Partial_DoNotMerge_ } from '../models/Partial_DoNotMerge_';
import type { Partial_ExcludedUrl_ } from '../models/Partial_ExcludedUrl_';
import type { Partial_PrioritizeListing_ } from '../models/Partial_PrioritizeListing_';
import type { Partial_SightmapUrl_ } from '../models/Partial_SightmapUrl_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DataPipelineManualFixesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public isAuthorized(): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/is_authorized',
        });
    }
    /**
     * @returns ControllerResponse_ProposedEdit_Array_ Ok
     * @throws ApiError
     */
    public listProposedEdits(): CancelablePromise<ControllerResponse_ProposedEdit_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/proposed_edits',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateProposedEdit(
        requestBody: {
            updates: {
                where_clause?: string;
                data?: string;
            };
            where: {
                id: string;
            };
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/data_pipeline_manual_fixes/proposed_edits',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public approveProposedEdit(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/data_pipeline_manual_fixes/proposed_edits/approve/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public deleteProposedEdit(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/data_pipeline_manual_fixes/proposed_edits/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ControllerResponse_DoNotMerge_Array_ Ok
     * @throws ApiError
     */
    public listDoNotMerge(): CancelablePromise<ControllerResponse_DoNotMerge_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/do_not_merge',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public insertDoNotMerge(
        requestBody: Omit_DoNotMerge_created_on_or_created_by_,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/data_pipeline_manual_fixes/do_not_merge',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateDoNotMerge(
        requestBody: {
            updates: Partial_DoNotMerge_;
            where: Record<string, any>;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/data_pipeline_manual_fixes/do_not_merge',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public deleteDoNotMerge(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/data_pipeline_manual_fixes/do_not_merge',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns ControllerResponse_ExcludedUrl_Array_ Ok
     * @throws ApiError
     */
    public listExcludedUrls(): CancelablePromise<ControllerResponse_ExcludedUrl_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/excluded_urls',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public insertExcludedUrl(
        requestBody: Omit_ExcludedUrl_created_on_or_created_by_,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/data_pipeline_manual_fixes/excluded_urls',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateExcludedUrl(
        requestBody: {
            updates: Partial_ExcludedUrl_;
            where: Record<string, any>;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/data_pipeline_manual_fixes/excluded_urls',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param url
     * @returns void
     * @throws ApiError
     */
    public deleteExcludedUrl(
        url: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/data_pipeline_manual_fixes/excluded_urls',
            query: {
                'url': url,
            },
        });
    }
    /**
     * @returns ControllerResponse_PrioritizeListing_Array_ Ok
     * @throws ApiError
     */
    public listPrioritizeListing(): CancelablePromise<ControllerResponse_PrioritizeListing_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/prioritize_listing',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public insertPrioritizeListing(
        requestBody: Omit_PrioritizeListing_created_on_or_created_by_,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/data_pipeline_manual_fixes/prioritize_listing',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updatePrioritizeListing(
        requestBody: {
            updates: Partial_PrioritizeListing_;
            where: Record<string, any>;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/data_pipeline_manual_fixes/prioritize_listing',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param buildingId
     * @param listingSource
     * @returns void
     * @throws ApiError
     */
    public deletePrioritizeListing(
        buildingId: string,
        listingSource: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/data_pipeline_manual_fixes/prioritize_listing',
            query: {
                'building_id': buildingId,
                'listing_source': listingSource,
            },
        });
    }
    /**
     * @returns ControllerResponse_AddressRename_Array_ Ok
     * @throws ApiError
     */
    public listAddressRename(): CancelablePromise<ControllerResponse_AddressRename_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/address_rename',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public insertAddressRename(
        requestBody: Omit_AddressRename_created_on_or_created_by_,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/data_pipeline_manual_fixes/address_rename',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateAddressRename(
        requestBody: {
            updates: Partial_AddressRename_;
            where: Record<string, any>;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/data_pipeline_manual_fixes/address_rename',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public deleteAddressRename(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/data_pipeline_manual_fixes/address_rename',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns ControllerResponse_AllowedWebsiteDomain_Array_ Ok
     * @throws ApiError
     */
    public listAllowedWebsiteDomains(): CancelablePromise<ControllerResponse_AllowedWebsiteDomain_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/allowed_website_domains',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public insertAllowedWebsiteDomain(
        requestBody: Omit_AllowedWebsiteDomain_created_on_or_created_by_,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/data_pipeline_manual_fixes/allowed_website_domains',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateAllowedWebsiteDomain(
        requestBody: {
            updates: Partial_AllowedWebsiteDomain_;
            where: Record<string, any>;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/data_pipeline_manual_fixes/allowed_website_domains',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public deleteAllowedWebsiteDomain(
        id: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/data_pipeline_manual_fixes/allowed_website_domains',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns ControllerResponse_BuildingOverride_Array_ Ok
     * @throws ApiError
     */
    public listBuildingOverrides(): CancelablePromise<ControllerResponse_BuildingOverride_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/building_overrides',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public insertBuildingOverride(
        requestBody: Omit_BuildingOverride_created_on_or_created_by_,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/data_pipeline_manual_fixes/building_overrides',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateBuildingOverride(
        requestBody: {
            updates: Partial_BuildingOverride_;
            where: Record<string, any>;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/data_pipeline_manual_fixes/building_overrides',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public deleteBuildingOverride(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/data_pipeline_manual_fixes/building_overrides',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns ControllerResponse_DoMergeAddress_Array_ Ok
     * @throws ApiError
     */
    public listDoMergeAddresses(): CancelablePromise<ControllerResponse_DoMergeAddress_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/do_merge_addresses',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public insertDoMergeAddress(
        requestBody: Omit_DoMergeAddress_created_on_or_created_by_,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/data_pipeline_manual_fixes/do_merge_addresses',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateDoMergeAddress(
        requestBody: {
            updates: Partial_DoMergeAddress_;
            where: Record<string, any>;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/data_pipeline_manual_fixes/do_merge_addresses',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param mergeGroupId
     * @param address
     * @returns void
     * @throws ApiError
     */
    public deleteDoMergeAddress(
        mergeGroupId: string,
        address: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/data_pipeline_manual_fixes/do_merge_addresses',
            query: {
                'merge_group_id': mergeGroupId,
                'address': address,
            },
        });
    }
    /**
     * @returns ControllerResponse_SightmapUrl_Array_ Ok
     * @throws ApiError
     */
    public listSightmapUrls(): CancelablePromise<ControllerResponse_SightmapUrl_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data_pipeline_manual_fixes/sightmap_urls',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public insertSightmapUrl(
        requestBody: Omit_SightmapUrl_created_on_or_created_by_,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/data_pipeline_manual_fixes/sightmap_urls',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateSightmapUrl(
        requestBody: {
            updates: Partial_SightmapUrl_;
            where: Record<string, any>;
        },
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/data_pipeline_manual_fixes/sightmap_urls',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param widgetHashId
     * @returns void
     * @throws ApiError
     */
    public deleteSightmapUrl(
        widgetHashId: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/data_pipeline_manual_fixes/sightmap_urls',
            query: {
                'widget_hash_id': widgetHashId,
            },
        });
    }
}
